import Cookies from 'universal-cookie'

export const checkUrl = () => {

  if (typeof window !== 'undefined') {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const gclid= urlParams.get('gclid')

    if(gclid) {
      // window.localStorage.setItem('gclid', gclid)
      
      const cookies = new Cookies();
      cookies.set('gclid', gclid)
    }
  };
};